import { useEffect, useRef } from 'react';
import { useToast } from '@aimsos/ui';

/**
 * Surface a failure as an error toast, exactly once per distinct error value
 * (CT-5092). The inline error UI stays the source of truth — this only mirrors
 * the same failure as a toast — and the guard resets when the error clears, so a
 * later, different failure toasts again while a re-render never re-spams the same
 * one. Extracted from the inbox split + detail page, where it was repeated 3×.
 *
 * @param {string|null|undefined} error  current error message (falsy = no error)
 * @param {string} title                 already-translated toast title
 */
export function useErrorToast(error, title) {
  const toast = useToast();
  const lastRef = useRef(null);
  useEffect(() => {
    if (error && lastRef.current !== error) {
      lastRef.current = error;
      toast.error({ title, message: error });
    } else if (!error) {
      lastRef.current = null;
    }
  }, [error, title, toast]);
}
